import { useSessionStore } from '@/stores/useSessionStore'

let refreshPromise = null

async function runRefresh() {
  if (!refreshPromise) {
    refreshPromise = (async () => {
      const session = useSessionStore()
      const res = await fetch('/api/auth/refresh', {
        method: 'POST',
        credentials: 'include'
      })

      if (!res.ok) {
        session.clearSession()
        throw new Error('登录已失效，请重新登录')
      }

      const data = await res.json()
      session.setAccessToken(data.accessToken, data.expiresIn)
      return data
    })().finally(() => {
      refreshPromise = null
    })
  }
  return refreshPromise
}

export async function httpRequest(path, options = {}) {
  const {
    method = 'GET',
    body,
    headers = {},
    skipAuth = false,
    retry = true,
    responseType = 'json',
    throwOnHttpError = true
  } = options

  const session = useSessionStore()
  const finalHeaders = { ...headers }

  let finalBody = body
  if (body && typeof body === 'object' && !(body instanceof FormData) && !(body instanceof Blob)) {
    finalBody = JSON.stringify(body)
    if (!finalHeaders['Content-Type']) {
      finalHeaders['Content-Type'] = 'application/json'
    }
  }

  if (!skipAuth && session.accessToken) {
    finalHeaders.Authorization = `Bearer ${session.accessToken}`
  }

  const response = await fetch(path, {
    method,
    body: finalBody,
    headers: finalHeaders,
    credentials: 'include'
  })

  if (response.status === 401 && !skipAuth && retry) {
    await runRefresh()
    return httpRequest(path, { ...options, retry: false })
  }

  if (!response.ok && throwOnHttpError) {
    let message = `请求失败(${response.status})`
    try {
      const data = await response.json()
      message = data?.error || message
    } catch (error) {
      // ignore
    }
    const err = new Error(message)
    err.status = response.status
    throw err
  }

  if (responseType === 'blob') {
    // 后端在异常时可能仍返回 JSON 错误体（如 422/500 的 ApiError），
    // 这里把“看起来是 JSON 错误”的 blob 转成可读异常，避免前端只看到无信息的失败。
    const ct = response.headers.get('content-type') || ''
    if (ct.includes('application/json')) {
      const text = await response.text()
      let message = `请求失败(${response.status})`
      try {
        const data = JSON.parse(text)
        message = data?.error || message
      } catch {
        // 非 JSON，退回原始文本（截断）
        message = text ? text.slice(0, 200) : message
      }
      const err = new Error(message)
      err.status = response.status
      throw err
    }
    return response.blob()
  }
  if (responseType === 'raw') {
    return response
  }
  if (responseType === 'text') {
    return response.text()
  }

  const contentType = response.headers.get('content-type') || ''
  if (contentType.includes('application/json')) {
    return response.json()
  }
  return null
}
